export default __webpack_public_path__ + "static/media/9.c979d54a.webp";